import { render, staticRenderFns } from "./PaySetting.vue?vue&type=template&id=d581be68&scoped=true"
import script from "./PaySetting.vue?vue&type=script&lang=js"
export * from "./PaySetting.vue?vue&type=script&lang=js"
import style0 from "./PaySetting.vue?vue&type=style&index=0&id=d581be68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d581be68",
  null
  
)

export default component.exports